// extracted by mini-css-extract-plugin
export default {"submittedImage":"SafetyCheckPage_submittedImage__1kODD"};